// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9fe216f","732":"422ec967","977":"58d1730a"}[chunkId] + ".chunk.js";
};